<template>
	<div class="home">
		<section class="nav">
			<a href="http://conflive.com" target="_blank"><img src="../assets/logo.png" class="logo"></a>
		</section>
		<section class="hero">
			<h1>{{ $t("home.title") }}</h1>
			<img src="../assets/phone.png" class="main-phone" v-bind:style="{marginTop: -500-phoneOffset + 'px', marginBottom: phoneOffset + 'px'}">
		</section>
		<section class="content column">
			<md-whiteframe md-elevation="2" class="md-padding col-sm-8 col-sm-offset-2">
				<div class="row">
					<p class="intro col-sm-8 col-sm-offset-2">
						{{ $t("home.intro") }}
					</p>
				</div>

				<h2>{{ $t("home.features") }}</h2>
				<div class="row">
					<div v-for="feature of features" class="feature col-md-4">
						<i class="fa" :class="feature.icon" aria-hidden="true"></i>
						<h3>{{$t(feature.title)}}</h3>
						<div v-if="feature.extra" class="extra"><span>Extra funkció</span></div>
						{{$t(feature.desc)}}
					</div>
				</div>
			</md-whiteframe>

			<md-whiteframe md-elevation="2" class="references md-padding col-sm-8 col-sm-offset-2">
				<h2>{{ $t("home.references") }}</h2>
				<div class="text">
					{{ $t("home.referencesDesc") }}

					<div class="row apps">
						<span class="col-sm-6 col-xs-12">
							<a href="https://itunes.apple.com/us/app/startup-safary/id1225499566?mt=8" target="_blank">
								<i class="fa fa-apple" aria-hidden="true"></i> iOS</br>
							</a>
						</span>

						<span class="col-sm-6 col-xs-12">
							<a href="https://play.google.com/store/apps/details?id=com.conflive.safary" target="_blank">
								<i class="fa fa-android" aria-hidden="true"></i> Android</br>
							</a>
						</span>
					</div>
				</div>

				<carousel-3d :width="294" :height="522" :autoplay="true" :autoplay-timeout="2000" >
					<slide :index="0">
						<img src="../assets/ex1.jpg">
					</slide>
					<slide :index="1">
						<img src="../assets/ex2.jpg">
					</slide>
					<slide :index="2">
						<img src="../assets/ex3.jpg">
					</slide>
					<slide :index="3">
						<img src="../assets/ex4.jpg">
					</slide>
					<slide :index="4">
						<img src="../assets/ex5.jpg">
					</slide>
					<slide :index="5">
						<img src="../assets/ex6.jpg">
					</slide>
				</carousel-3d>
			</md-whiteframe>

			<md-whiteframe md-elevation="2" class="contact md-padding col-sm-8 col-sm-offset-2">
				<!--
				<h2>{{ $t("home.team") }}</h2>
				<div class="text">
					<div class="row center-xs">
						<span v-for="member of team" class="col-sm-4 col-xs-12">
							<img :src="imgUrl(member.image)"></br>
							{{member.name}}</br>
							{{member.desc}}
						</span>
					</div></br></br>
				</div>
				-->
				<h2>{{ $t("home.contact") }}</h2>
				<div class="text">
					{{ $t("home.contactDesc") }}</br>
					<a href="mailto:info@conflive.com">info@conflive.com</a>
				</div>
			</md-whiteframe>
		</section>
	</div>
</template>

<script>
	import { Carousel3d, Slide } from 'vue-carousel-3d';

	var images = require.context('../assets/', false, /\.jpg$/)

	export default {
		name: 'home',
		components: {
			Carousel3d,
			Slide
		},
		data () {
			return {
				phoneOffset: -500,
				features: [
				{
					'icon': 'fa-bars',
					'title': 'home.feats.1title',
					'desc': 'home.feats.1desc'
				},
				{
					'icon': 'fa-diamond',
					'title': 'home.feats.2title',
					'desc': 'home.feats.2desc'
				},
				{
					'icon': 'fa-star-half-o',
					'title': 'home.feats.3title',
					'desc': 'home.feats.3desc'
				},
				{
					'icon': 'fa-exclamation-triangle',
					'title': 'home.feats.4title',
					'desc': 'home.feats.4desc'
				},
				{
					'icon': 'fa-question-circle',
					'title': 'home.feats.5title',
					'desc': 'home.feats.5desc'
				},
				{
					'icon': 'fa-mobile-phone',
					'title': 'home.feats.6title',
					'desc': 'home.feats.6desc'
				},
				{
					'icon': 'fa-clock-o',
					'title': 'home.feats.7title',
					'desc': 'home.feats.7desc'
				},
				{
					'icon': 'fa-map',
					'title': 'home.feats.8title',
					'desc': 'home.feats.8desc'
				},
				{
					'icon': 'fa-wrench',
					'title': 'home.feats.9title',
					'desc': 'home.feats.9desc'
				}
				],
				team: [
				{
					"name": "Dániel Eke",
					"desc": "CEO and software developer",
					"image": "ekedaniel.jpg"
				},
				{
					"name": "Levente Bernáth",
					"desc": "Mobile development",
					"image": "bernathlevente.jpg"
				},
				{
					"name": "Manó Barna Czár",
					"desc": "PR and tech support",
					"image": "barnamano.jpg"
				}
				]
			}
		},
		methods: {
			handleScroll () {
				this.phoneOffset = Math.min(-(500-window.scrollY), 0);
			},
			imgUrl: function (path) {
				return images('./' + path)
			}
		},
		mounted () {
			window.addEventListener('scroll', this.handleScroll);
		}
	}
</script>

<style scoped>
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.logo{
		height: 64px;
	}

	.hero{
		min-height: 400px;
	}

	.content{
		padding-bottom: 32px;
	}

	.md-whiteframe{
		margin-bottom: 16px;
		text-align: left;
	}

	.intro{
		text-align: justify;
	}

	.feature{
		margin-bottom: 16px;
	}

	.feature .fa{
		font-size: 32pt;
	}

	.extra {
		margin-bottom: 8px;
	}

	.extra span{
		padding: 4px;
		background-color: #673ab7;
		color: white;
		font-weight: bold;
		border-radius: 4px;
	}

	.references .text, .contact .text{
		text-align: center;
	}

	.apps{
		font-size: 20pt;
		margin: 16px 0;
	}

	.contact .text img{
		max-width: 100px;
		border-radius: 50px;
	}
</style>



// WEBPACK FOOTER //
// Home.vue?74814849